import { FiMail, FiShield, FiPhone } from 'react-icons/fi';
import styles from './LandingLayout.module.css';

const ContactPage = () => (
  <section className={styles.section}>
    <div className={styles.sectionInner}>
      <div className={styles.sectionLabel}>Get in Touch</div>
      <h2 className={styles.sectionTitle}>Contact Us</h2>
      <p className={styles.sectionLead}>
        JainamSevaSetu helps Jain community temples manage donations and funding. Have a question,
        need support, or want to register your Derasar? Reach out and we'll respond within one business day.
      </p>
      <div className={styles.contactGrid}>
        <div className={styles.contactCard}>
          <div className={styles.contactIcon}><FiMail size={22} /></div>
          <h3>General Support</h3>
          <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>
          <p>For general queries, technical issues, or account help</p>
        </div>
        <div className={styles.contactCard}>
          <div className={styles.contactIcon}><FiShield size={22} /></div>
          <h3>Privacy &amp; Legal</h3>
          <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>
          <p>For data deletion requests, privacy concerns, or legal enquiries</p>
        </div>
        <div className={styles.contactCard}>
          <div className={styles.contactIcon}><FiPhone size={22} /></div>
          <h3>Register a Derasar</h3>
          <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>
          <p>To register your temple or enquire about subscription plans</p>
        </div>
        <div className={styles.contactCard}>
          <div className={styles.contactIcon}><FiPhone size={22} /></div>
          <h3>Phone Support</h3>
          <p className={styles.contactName}>Nilesh Parekh</p>
          <a href="tel:+919773096017">+91 97730 96017</a>
          <a href="tel:+919374628421">+91 93746 28421</a>
          <p>Available for direct queries and Derasar registration assistance</p>
        </div>
      </div>
    </div>
  </section>
);

export default ContactPage;
